<template>
  <div v-if="page">
    <BaseHeading
      v-viewport-animated="{ mode: 'fade-translate' }"
      :content="page.content"
      :lead="page.lead"
      :date="page.publication_date"
      :image="page.image"
      :title="page.page_header"
      :cta-button="page.cta_button"
    />
    <Widgets :widgets="page.widgets" virtual-first-widget />
  </div>
  <div v-else />
</template>

<script lang="ts" setup>
import { useBreadcrumbs } from '@/state/breadcrumbs'
import { useAnimationDisabled } from '@/state/pixelAnimationData'

const route = useRoute()

const slug = flatten(route.params.slug)
const { data: page, error } = await useAsyncData(
  async () => await useApi().publicPagesNewsRetrieve(slug)
)

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

const pixelAnimationDisabled = useAnimationDisabled()
pixelAnimationDisabled.value = Boolean(page.value?.pixels_disabled)

const { setBreadcrumbs } = useBreadcrumbs()

if (page.value)
  setBreadcrumbs([
    {
      text: page.value.breadcrumb?.title,
      to: {
        name: 'slug',
        params: { slug: page.value.breadcrumb?.slug }
      }
    },
    {
      text: page.value.title,
      to: { name: 'news-slug', params: { slug: page.value.slug } }
    }
  ])

defineI18nRoute({
  paths: {
    pl: '/news/[slug]'
  }
})

const setI18nParams = useSetI18nParams()
setI18nParams({
  pl: { slug: page?.value?.slug_pl },
  en: { slug: page?.value?.slug_en }
})

const meta = usePrepareSEOMeta(page)

useHead({
  title: page.value?.site_title,
  meta
})
</script>
